module.exports = __webpack_public_path__ + "static/img/vr_hy_v1_max.b1667cdc.png";